export const MATCH_STATUSES = {
  unresponsive: {
    name: 'unresponsive',
    displayName: 'unresponsive',
    next: [],
  },
  unreplied: {
    name: 'unreplied',
    displayName: 'new lead',
    tooltip: 'Reply within 48 hours to improve your chances of winning this job',
    next: ['potential', 'rejected'],
  },
  matched: {
    name: 'matched',
    displayName: 'new lead',
    tooltip: 'Reply within 48 hours to improve your chances of winning this job',
    next: ['potential', 'rejected'],
  },
  accepted: {
    name: 'accepted',
    displayName: 'new lead',
    tooltip: 'Reply within 48 hours to improve your chances of winning this job',
    action: 'accept',
    next: ['potential'],
  },
  potential: {
    name: 'potential',
    displayName: 'potential',
    tooltip: 'You must update the status of potential jobs every two weeks until the customer makes a decision on next steps',
    action: 'potential',
    next: ['hired', 'closed'],
  },
  hired: {
    name: 'hired',
    displayName: 'hired',
    tooltip: 'You must update the status of in progress jobs every two weeks until they are complete.',
    icon: 'tool-wrench',
    action: 'hire',
    next: ['completed', 'canceled'],
    questions: {
      default: 'Are you hired?',
    },
  },
  completed: {
    name: 'completed',
    displayName: 'complete',
    icon: 'filled-check',
    action: 'complete',
    next: [],
    questions: {
      default: 'Have you completed this request?',
    },
  },
  rejected: {
    name: 'rejected',
    displayName: 'rejected',
    protected: true,
    icon: 'plus-circle-filled',
    iconClass: 'rotate45',
    action: 'reject',
    next: [],
  },
  canceled: {
    name: 'canceled',
    displayName: 'canceled',
    protected: true,
    icon: 'plus-circle-filled',
    iconClass: 'rotate45',
    action: 'cancel',
    next: [],
  },
  closed: {
    name: 'closed',
    displayName: 'not hired',
    protected: true,
    icon: 'plus-circle-filled',
    iconClass: 'rotate45',
    action: 'close',
    next: [],
  },
};


function _createGroupFromStatuses (key, statuses) {
  return {
    key,
    statuses: statuses.map(status => status.name),
  };
}

// TODO: This is unncessary, remember to remove once either `all matches` logic for
// TODO: consumer and pro is seperated or pro stops receiving `unresponsive` matches
export const ALL_MATCHES = _createGroupFromStatuses('all', Object.values(MATCH_STATUSES));
export const NEW_MATCHES = _createGroupFromStatuses('new', [MATCH_STATUSES.unreplied, MATCH_STATUSES.matched, MATCH_STATUSES.accepted]);
export const CURRENT_MATCHES = _createGroupFromStatuses('current', [MATCH_STATUSES.potential, MATCH_STATUSES.hired]);
export const PAST_MATCHES = _createGroupFromStatuses('past', [
  MATCH_STATUSES.canceled,
  MATCH_STATUSES.completed,
  MATCH_STATUSES.rejected,
  MATCH_STATUSES.closed,
]);

// TODO: Remove group logic from codebase
export const STATUS_GROUPS = {
  [ALL_MATCHES.key]: ALL_MATCHES,
  [NEW_MATCHES.key]: NEW_MATCHES,
  [CURRENT_MATCHES.key]: CURRENT_MATCHES,
  [PAST_MATCHES.key]: PAST_MATCHES,
};

// TODO: Update this enum on toolkit
export const NEW_MATCH_STATUSES = {
  UNRESPONSIVE: 'unresponsive',
  UNREPLIED: 'unreplied',
  ACCEPTED: 'accepted',
  MATCHED: 'matched',
  POTENTIAL: 'potential',
  HIRED: 'hired',
  COMPLETED: 'completed',
  REJECTED: 'rejected',
  CANCELED: 'cancelled',
  CLOSED: 'closed',
};

const {
  UNRESPONSIVE,
  UNREPLIED,
  ACCEPTED,
  POTENTIAL,
  MATCHED,
  HIRED,
  COMPLETED,
  REJECTED,
  CANCELED,
  CLOSED,
} = NEW_MATCH_STATUSES;

export const MATCH_STATUS_ACTIONS = {
  SEE: 'see',
  ACCEPT: 'accepted',
  CALL_CONSUMER: 'called-consumer',
  REJECT: 'rejected',
  HIRE: 'hired',
  CLOSE: 'closed',
  COMPLETE: 'completed',
  CANCEL: 'cancelled',
  CANCEL_ALL: 'cancel-all',
  ASK_LATER: 'ask-later',
  REACTIVATE: 'potential',
};

export const MATCH_STATUS_ALIASES = {
  search: {
    key: 'search',
    label: 'search',
    statuses: [],
  },
  new: {
    key: 'new',
    label: 'new',
    statuses: [UNREPLIED, ACCEPTED],
    ctas: {
      call: {
        key: 'call',
        action: MATCH_STATUS_ACTIONS.CALL_CONSUMER,
        from: 'new',
        to: 'potential',
        label: 'Show Number',
        shortLabel: 'Call',
        icon: 'phone',
      },
      message: {
        key: 'message',
        action: MATCH_STATUS_ACTIONS.CALL_CONSUMER,
        from: 'new',
        to: 'potential',
        label: 'Message',
        icon: 'chat-bubbles',
      },
      pass: {
        key: 'pass',
        action: MATCH_STATUS_ACTIONS.REJECT,
        from: 'new',
        to: 'past',
        label: 'Pass',
      },
    },
  },
  unreplied: {
    key: 'new',
    label: 'new',
    statuses: [UNREPLIED, ACCEPTED],
    ctas: {
      call: {
        key: 'call',
        action: MATCH_STATUS_ACTIONS.CALL_CONSUMER,
        from: 'new',
        to: 'potential',
        label: 'Show Number',
        shortLabel: 'Call',
        icon: 'phone',
      },
      message: {
        key: 'message',
        action: MATCH_STATUS_ACTIONS.CALL_CONSUMER,
        from: 'new',
        to: 'potential',
        label: 'Message',
        icon: 'chat-bubbles',
      },
      pass: {
        key: 'pass',
        action: MATCH_STATUS_ACTIONS.REJECT,
        from: 'new',
        to: 'past',
        label: 'Pass',
      },
    },
  },
  potential: {
    key: 'potential',
    label: 'potential',
    statuses: [POTENTIAL],
    question: 'Did you take the job?',
    ctas: {
      yes: {
        key: 'yes',
        action: MATCH_STATUS_ACTIONS.HIRE,
        from: 'potential',
        to: 'hired',
        label: 'Hired – job is in progress',
        confirmation: 'Are you sure you want to mark this job as Hired?',
      },
      no: {
        key: 'no',
        action: MATCH_STATUS_ACTIONS.CLOSE,
        from: 'potential',
        to: 'past',
        label: 'Closed – job is no longer active',
        confirmation: 'Are you sure you want to close this job?',
        message: 'Once closed, you may still reactivate this job from your Archive to continue working on it.',
      },
    },
  },
  hired: {
    key: 'hired',
    label: 'hired',
    statuses: [HIRED],
    question: 'Did you complete the job?',
    ctas: {
      yes: {
        key: 'yes',
        action: MATCH_STATUS_ACTIONS.COMPLETE,
        from: 'hired',
        to: 'completed',
        label: 'Complete – job is finished',
        confirmation: 'Are you sure you want to mark this job as Complete and request a review?',
      },
      no: {
        key: 'no',
        action: MATCH_STATUS_ACTIONS.CANCEL,
        from: 'hired',
        to: 'past',
        label: 'Canceled – job is no longer active',
        confirmation: 'Are you sure you want to cancel this job?',
        message: 'Please note that once you cancel a job, it cannot be reactivated. You can still view them in the archive if needed.',
      },
    },
  },
  completed: {
    key: 'completed',
    label: 'complete',
    statuses: [COMPLETED],
  },
  past: {
    key: 'past',
    label: 'archive',
    statuses: [CANCELED, REJECTED, CLOSED, UNRESPONSIVE],
  },
  closed: {
    key: 'closed',
    label: 'closed',
    statuses: [CLOSED],
    ctas: {
      reactivate: {
        key: 'reactivate',
        action: MATCH_STATUS_ACTIONS.REACTIVATE,
        from: 'past',
        to: 'potential',
        label: 'Reactivate Job',
      },
    },
  },
};

export const MATCH_STATUS_LABELS = {
  [UNRESPONSIVE]: 'expired',
  [UNREPLIED]: 'new',
  [ACCEPTED]: 'new',
  [MATCHED]: 'new',
  [POTENTIAL]: 'potential',
  [HIRED]: 'hired',
  [COMPLETED]: 'completed',
  [REJECTED]: 'passed',
  [CANCELED]: 'canceled',
  [CLOSED]: 'closed',
};

export const ACTIVE_MATCH_STATUSES = [
  UNREPLIED,
  ACCEPTED,
  MATCHED,
  POTENTIAL,
  HIRED,
  COMPLETED,
  CLOSED,
];

export const PAST_MATCH_STATUSES = [REJECTED, CLOSED, CANCELED, UNRESPONSIVE];

export const CONTACTED_STATUSES = [ACCEPTED, POTENTIAL, HIRED, COMPLETED, CLOSED, CANCELED];

export const PASSED_STATUSES = [REJECTED];

export const IGNORED_STATUSES = [UNREPLIED, UNRESPONSIVE];

export const getMatchStatusActionsMessage = ({ action, firstName }) => {
  switch (action) {
    case MATCH_STATUS_ACTIONS.REACTIVATE:
    case MATCH_STATUS_ACTIONS.CALL_CONSUMER:
      return 'This job status is now Potential';
    case MATCH_STATUS_ACTIONS.REJECT:
      return "You passed on this job and it's saved in the Archive";
    case MATCH_STATUS_ACTIONS.HIRE:
      return 'This job status is now Hired';
    case MATCH_STATUS_ACTIONS.CLOSE:
      return 'This job has been closed and saved in the Archive';
    case MATCH_STATUS_ACTIONS.CANCEL:
      return 'This job has been canceled and saved in the Archive';
    case MATCH_STATUS_ACTIONS.COMPLETE:
      return `This job status is now Complete. We’ve asked ${firstName} to leave you a review.`;
    default:
      return '';
  }
};
